export default "__VITE_ASSET__T4gh1Uwm__"